import TalentDetail from '../../views/talent/Detail.vue';

window.Vue.component('talent-detail', TalentDetail);
